<template>
  <transition name="slide-fade">
    <div class="panel">
      <p class="intro-text">
        You can download, print, and use the PainGuide worksheets available here
        to support your self-care practices. These tools can help you build
        resilience, develop a relaxation practice, assist you in reframing your
        thoughts to improve how you feel, and manage your emotions. There’s also
        a worksheet to help you prepare for visits with your healthcare provider
        to make sure that you get what you need from the conversations. The more
        you practice these skills, the more effective you will be. Good luck!
      </p>

      <ul>
        <li>
          <a
            href="/worksheets/RESILIENCE_Worksheet_Three_Good_Things_001.pdf"
            target="_blank"
            >RESILIENCE_Worksheet_Three_Good_Things_001.pdf</a
          >
          <br />
          Use this worksheet to build resilience by focusing on positive aspects
          of your life
        </li>

        <li>
          <a
            href="/worksheets/RESILIENCE_Worksheet_Signature_Strengths_001.pdf"
            target="_blank"
            >RESILIENCE_Worksheet_Signature_Strengths_001.pdf</a
          >
          <br />
          Use this worksheet to identify your signature strengths and put them
          to work
        </li>

        <li>
          <a
            href="/worksheets/RESILIENCE_Worksheet_Savoring_001.pdf"
            target="_blank"
            >RESILIENCE_Worksheet_Savoring_001.pdf</a
          >
          <br />
          Use this worksheet to help you savor life’s pleasures, both small and
          large!
        </li>

        <li>
          <a
            href="/worksheets/RESILIENCE_Worksheet_Kindness_001.pdf"
            target="_blank"
            >RESILIENCE_Worksheet_Kindness_001.pdf</a
          >
          <br />
          Use this worksheet to document the acts of kindness that you extend to
          others and to yourself
        </li>

        <li>
          <a
            href="/worksheets/RESILIENCE_Worksheet_Gratitude_001.pdf"
            target="_blank"
            >RESILIENCE_Worksheet_Gratitude_001.pdf</a
          >
          <br />
          Use this worksheet to start a gratitude journal
        </li>

        <li>
          <a href="/worksheets/RELAXATION_worksheet_001.pdf" target="_blank"
            >RELAXATION_worksheet_001.pdf</a
          >
          <br />
          Use this worksheet to schedule and track your relaxation practice
        </li>

        <li>
          <a href="/worksheets/REFRAMING_worksheet_001.pdf" target="_blank"
            >REFRAMING_worksheet_001.pdf</a
          >
          <br />
          Use this worksheet to practice reframing negative thoughts to make you
          feel more positive
        </li>

        <li>
          <a
            href="/worksheets/Managing_Emotions_worksheet_Stress_Management_001.pdf"
            target="_blank"
            >Managing_Emotions_worksheet_Stress_Management_001.pdf</a
          >
          <br />
          Use this worksheet to identify your stress triggers and develop a plan
          to handle them
        </li>

        <li>
          <a
            href="/worksheets/Managing_Emotions_worksheet_PleasantActivityScheduling_001.pdf"
            target="_blank"
            >Managing_Emotions_worksheet_PleasantActivityScheduling_001.pdf</a
          >
          <br />
          Use this worksheet to help you to plan time for enjoyable activities
          each and every week
        </li>

        <li>
          <a
            href="/worksheets/Communication_worksheet_Working_With_Your_HCP_001.pdf"
            target="_blank"
            >Communication_worksheet_Working_With_Your_HCP_001.pdf</a
          >
          <br />
          Use this worksheet to help you prepare for visits with your healthcare
          provider and get the most out of your visits
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  async created() {
    this.changePageTitle("Self-care Worksheets");
    this.changePageIntroText("");
  },

  methods: {
    ...mapMutations(["changePageTitle", "changePageIntroText"]),
  },
};
</script>

<style scoped>
ul {
  margin-top: 2rem;
}

li {
  margin-bottom: 2rem;
}

a {
  color: var(--black);
  font-size: 1.125rem;
  font-weight: 600;
}

a:hover,
a:focus {
  color: var(--michigan-blue);
}

.panel {
  font-weight: 500;
  padding: 2rem;
}

.intro-text {
  line-height: 1.5;
}
</style>
